module.exports = __webpack_public_path__ + "img/featured.2ff5a155.jpg";